import React from 'react';
import { Link } from 'react-router';
import ManagePageLayout from '../../common/PageLayout/Manage';

const NotFoundPage = React.createClass({
    render: function() {
        return (
            <ManagePageLayout>
                <div className="NotFoundPage">
                    <h1>Page not found.</h1>
                    <p>Please <a href="mailto:support@red-gate.com">let us know</a> about the broken link, then head back to the <Link to="/">home page</Link></p>
                </div>
            </ManagePageLayout>
        );
    }
});

export default NotFoundPage;


// WEBPACK FOOTER //
// ./src/components/home/NotFoundPage/index.jsx